import Report from './index';

export default Report;
